import { RootState } from 'src/state/types';

export const selectErrors = (state: RootState): Error[] => state.errors.errors;

export const selectHasErrors = (state: RootState): boolean => selectErrors(state).length > 0;
